import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ScrollToTop } from '@/components/ScrollToTop';
import {
    HomePage,
    ImpressumPage,
    DatenschutzPage,
    AGBPage,
    AboutPage,
    ContactPage,
} from '@/pages';
import ProductReviewPage from '@/pages/ProductReviewPage';
import { UrlParamsProvider } from '@/contexts/UrlParamsContext';

function App() {
    return (
        <UrlParamsProvider>
            <Router>
                <ScrollToTop />
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/produkt/:slug" element={<ProductReviewPage />} />
                    <Route path="/impressum" element={<ImpressumPage />} />
                    <Route path="/datenschutz" element={<DatenschutzPage />} />
                    <Route path="/agb" element={<AGBPage />} />
                    <Route path="/ueber-uns" element={<AboutPage />} />
                    <Route path="/kontakt" element={<ContactPage />} />
                </Routes>
            </Router>
        </UrlParamsProvider>
    );
}

export default App;
